/** @jsxImportSource @emotion/react */
import { Navbar } from '@quickbit/qb-design-system';
import { Outlet } from 'react-router-dom';
import { signOut } from '../api/auth';
import { Tab } from '../components';
import { useSession, useSetSession } from '../context/Session';
import { useTabs } from '../context/Tabs';

interface Props {
  merchantName: string | undefined;
}

export const SidebarLayout = ({ merchantName }: Props) => {
  const { tabs } = useTabs();
  const session = useSession();
  const setSession = useSetSession();

  const logoutUser = () => {
    setSession({ authenticated: false });
    void signOut();
  };

  const realTabs = tabs.map((tab) => <Tab key={tab.name} tab={tab} />);

  return (
    <Navbar
      tabs={realTabs}
      logoutUser={logoutUser}
      loggedInUser={session.authenticated ? session.email : ''}
      merchantName={merchantName}
    >
      <Outlet />
    </Navbar>
  );
};
